import { SIZE_FULL } from '@/lib/gridElements/size';
import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostEngagingPostsConfig = {
    title: 'chart.instagram.widget_most_engaging_posts',
    id: 'widget_most_engaging_posts',
    size: SIZE_FULL,
    sortFields: [
        'engagement_rate',
        'engagement_on_reach',
        'created',
        'likes',
        'comments',
        'reach',
        'impressions',
        'saves',
        'plays',
        'shares'
    ],
    type: 'widget',
    element: MediasWidget
};
